import ScientificCouncilUpdateModal from "./ScientificCouncilUpdateModal";

export default ScientificCouncilUpdateModal;

